"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasMarkOfType = exports.BehaviourBuilder = exports.BuilderError = exports.KeyModifier = exports.PasteType = exports.KeyType = exports.Position = void 0;
var assert_1 = __importDefault(require("assert"));
var Text_1 = require("ContentTokens/Models/Text");
var lodash_1 = __importStar(require("lodash"));
var slate_1 = require("slate");
var EditorTypes_1 = require("./../EditorTypes");
var Utils_1 = require("../Utils");
var EditorWidgetRegistry_1 = require("../WidgetRegistry/EditorWidgetRegistry");
var Position;
(function (Position) {
    Position[Position["Any"] = 0] = "Any";
    Position[Position["Start"] = 1] = "Start";
    Position[Position["Middle"] = 2] = "Middle";
    Position[Position["End"] = 3] = "End";
})(Position || (exports.Position = Position = {}));
var KeyType;
(function (KeyType) {
    KeyType["Any"] = "";
    KeyType["Enter"] = "Enter";
    KeyType["Backspace"] = "Backspace";
    KeyType["Delete"] = "Delete";
    KeyType["Tab"] = "Tab";
    KeyType["I"] = "i";
    KeyType["B"] = "b";
    KeyType["K"] = "k";
    KeyType["Dash"] = "-";
    KeyType["Escape"] = "Escape";
    KeyType["AngleBracketClose"] = ">";
    KeyType["ArrowUp"] = "ArrowUp";
    KeyType["ArrowDown"] = "ArrowDown";
    KeyType["ArrowLeft"] = "ArrowLeft";
    KeyType["ArrowRight"] = "ArrowRight";
    KeyType["Space"] = " ";
    KeyType["Ctrl"] = "Control";
    KeyType["CurlyBracketOpen"] = "{";
    KeyType["BackTick"] = "`";
    KeyType["CloseBracket"] = ")";
    KeyType["OpenBracket"] = "(";
    KeyType["CloseSquareBracket"] = "]";
    KeyType["CapitalP"] = "P";
    KeyType["CapitalD"] = "D";
    KeyType["CapitalO"] = "O";
    KeyType["Line"] = "|";
    KeyType["Slash"] = "/";
    KeyType["Three"] = "3";
    KeyType["Colon"] = ":";
    KeyType["Plus"] = "+";
    KeyType["Comma"] = ",";
    KeyType["Period"] = ".";
})(KeyType || (exports.KeyType = KeyType = {}));
var PasteType;
(function (PasteType) {
    PasteType["Html"] = "html";
    PasteType["Fragment"] = "fragment";
    PasteType["Node"] = "node";
    PasteType["Rich"] = "rich";
    PasteType["Text"] = "text";
    PasteType["Files"] = "files";
})(PasteType || (exports.PasteType = PasteType = {}));
var KeyModifier;
(function (KeyModifier) {
    KeyModifier["CtrlCmd"] = "ControlCommand";
    KeyModifier["Ctrl"] = "Control";
    KeyModifier["Shift"] = "Shift";
    KeyModifier["Alt"] = "Alt";
    KeyModifier["Meta"] = "Meta";
    KeyModifier["Any"] = "Any";
    KeyModifier["None"] = "None";
})(KeyModifier || (exports.KeyModifier = KeyModifier = {}));
var BuilderError;
(function (BuilderError) {
    BuilderError["MissingPreconditionWithKey"] = "Attempting to set withKey without checking that it is a key event first";
    BuilderError["MissingPreconditionWithData"] = "Attempting to set withData without checking that it is a custom event first";
    BuilderError["MissingPreconditionCollapsed"] = "Attempting to set selection position without checking that selection is collapsed";
    BuilderError["MissingPreconditionModifiers"] = "Attempting to set both isKeyModifier and isOneOfKeyModifiers";
    BuilderError["MissingName"] = "Behaviour was not given a name";
    BuilderError["PasteTypeWrongEvent"] = "A paste event type was assigned in a non-paste behaviour";
})(BuilderError || (exports.BuilderError = BuilderError = {}));
var BehaviourBuilder = (function () {
    function BehaviourBuilder() {
        this.flags = {
            inBlockPosition: Position.Any,
            inMarkPosition: Position.Any,
            inBlockType: [EditorTypes_1.BlockType.Any],
            inMarkType: EditorTypes_1.MarkType.Any,
            isEventType: EditorTypes_1.EventType.Any,
            isKey: KeyType.Any,
            notInBlockType: [],
        };
        this.name = "unnamed";
    }
    BehaviourBuilder.prototype.doAction = function (action) {
        if (this.name == "unnamed") {
            throw new Error(BuilderError.MissingName);
        }
        return this.createBehaviour(this.flags, this.name, action);
    };
    BehaviourBuilder.prototype.isCalled = function (name) {
        this.name = name;
        return this;
    };
    BehaviourBuilder.prototype.isEvent = function (event) {
        this.flags.isEventType = event;
        return this;
    };
    BehaviourBuilder.prototype.withKey = function (key) {
        (0, assert_1.default)(this.flags.isEventType == EditorTypes_1.EventType.Key, BuilderError.MissingPreconditionWithKey);
        this.flags.isKey = key;
        return this;
    };
    BehaviourBuilder.prototype.withModifier = function (modifier) {
        (0, assert_1.default)(this.flags.isEventType == EditorTypes_1.EventType.Key, BuilderError.MissingPreconditionWithKey);
        (0, assert_1.default)(!this.flags.isOneOfKeyModifiers, BuilderError.MissingPreconditionModifiers);
        this.flags.isKeyModifier = modifier;
        return this;
    };
    BehaviourBuilder.prototype.withOneOfKeyModifiers = function (modifiers) {
        (0, assert_1.default)(this.flags.isEventType == EditorTypes_1.EventType.Key, BuilderError.MissingPreconditionWithKey);
        (0, assert_1.default)(!this.flags.isKeyModifier, BuilderError.MissingPreconditionModifiers);
        this.flags.isOneOfKeyModifiers = modifiers;
        return this;
    };
    BehaviourBuilder.prototype.withData = function (data) {
        (0, assert_1.default)(this.flags.isEventType == EditorTypes_1.EventType.Toolbar ||
            this.flags.isEventType == EditorTypes_1.EventType.Widget ||
            this.flags.isEventType == EditorTypes_1.EventType.SyntheticSelection ||
            this.flags.isEventType == EditorTypes_1.EventType.Insert, BuilderError.MissingPreconditionWithData);
        this.flags.withData = data;
        return this;
    };
    BehaviourBuilder.prototype.selectionIsCollapsed = function () {
        this.flags.isCollapsed = true;
        return this;
    };
    BehaviourBuilder.prototype.selectionIsExpanded = function () {
        this.flags.isCollapsed = false;
        return this;
    };
    BehaviourBuilder.prototype.atStartOfBlock = function () {
        this.flags.inBlockPosition = Position.Start;
        return this;
    };
    BehaviourBuilder.prototype.atEndOfBlock = function () {
        this.flags.inBlockPosition = Position.End;
        return this;
    };
    BehaviourBuilder.prototype.inMiddleOfBlock = function () {
        (0, assert_1.default)(this.flags.isCollapsed == true, BuilderError.MissingPreconditionCollapsed);
        this.flags.inBlockPosition = Position.Middle;
        return this;
    };
    BehaviourBuilder.prototype.atEndOfMark = function (type) {
        this.flags.inMarkPosition = Position.End;
        this.flags.inMarkType = type;
        return this;
    };
    BehaviourBuilder.prototype.inSingleBlock = function () {
        this.flags.inSingleBlock = true;
        return this;
    };
    BehaviourBuilder.prototype.inBlockType = function (type) {
        if (type instanceof Array) {
            this.flags.inBlockType = type;
        }
        else {
            this.flags.inBlockType = [type];
        }
        return this;
    };
    BehaviourBuilder.prototype.notInBlockType = function (type) {
        if (type instanceof Array) {
            if (lodash_1.default.includes(type, EditorTypes_1.BlockType.Any)) {
                throw new Error("You cannot specify BlockType.Any as a block to not be in");
            }
            this.flags.notInBlockType = type;
        }
        else {
            if (type === EditorTypes_1.BlockType.Any) {
                throw new Error("You cannot specify BlockType.Any as a block to not be in");
            }
            this.flags.notInBlockType = [type];
        }
        return this;
    };
    BehaviourBuilder.prototype.hasBlockBefore = function (type) {
        if (type instanceof Array) {
            this.flags.hasBlockBefore = type;
        }
        else {
            this.flags.hasBlockBefore = [type];
        }
        return this;
    };
    BehaviourBuilder.prototype.hasBlockAfter = function (type) {
        if (type instanceof Array) {
            this.flags.hasBlockAfter = type;
        }
        else {
            this.flags.hasBlockAfter = [type];
        }
        return this;
    };
    BehaviourBuilder.prototype.hasInlineBefore = function (type) {
        if (type instanceof Array) {
            this.flags.hasInlineBefore = type;
        }
        else {
            this.flags.hasInlineBefore = [type];
        }
        return this;
    };
    BehaviourBuilder.prototype.hasInlineAfter = function (type) {
        if (type instanceof Array) {
            this.flags.hasInlineAfter = type;
        }
        else {
            this.flags.hasInlineAfter = [type];
        }
        return this;
    };
    BehaviourBuilder.prototype.inInlineType = function (type) {
        if (type instanceof Array) {
            this.flags.inInlineType = type;
        }
        else {
            this.flags.inInlineType = [type];
        }
        return this;
    };
    BehaviourBuilder.prototype.inFirstBlock = function () {
        this.flags.inFirstBlock = true;
        return this;
    };
    BehaviourBuilder.prototype.inLastBlock = function () {
        this.flags.inLastBlock = true;
        return this;
    };
    BehaviourBuilder.prototype.inTableCell = function () {
        return this.isOfAncestry("tableCell");
    };
    BehaviourBuilder.prototype.notInTable = function () {
        this.flags.inTableCell = false;
        return this;
    };
    BehaviourBuilder.prototype.isOfAncestry = function (ancestorBlock) {
        this.flags.isOfAncestry = Array.isArray(ancestorBlock) ? ancestorBlock : [ancestorBlock];
        return this;
    };
    BehaviourBuilder.prototype.isNotOfAncestry = function (ancestorBlock) {
        this.flags.isNotOfAncestry = Array.isArray(ancestorBlock) ? ancestorBlock : [ancestorBlock];
        return this;
    };
    BehaviourBuilder.prototype.inEmptyBlock = function () {
        this.flags.hasAnyContent = false;
        return this;
    };
    BehaviourBuilder.prototype.inNonEmptyBlock = function () {
        this.flags.hasAnyContent = true;
        return this;
    };
    BehaviourBuilder.prototype.inFirstElementofContainer = function () {
        this.flags.inFirstElementOfContainer = true;
        return this;
    };
    BehaviourBuilder.prototype.hasTextSequence = function (sequence) {
        this.flags.textSequence = sequence;
        return this;
    };
    BehaviourBuilder.prototype.hasBlockContent = function (content) {
        this.flags.textContent = content;
        return this;
    };
    BehaviourBuilder.prototype.inFullySelectedRegistryWidget = function () {
        this.flags.inFullySelectedRegistryWidget = true;
        return this;
    };
    BehaviourBuilder.prototype.hasVoidBefore = function () {
        this.flags.hasVoidBefore = true;
        return this;
    };
    BehaviourBuilder.prototype.hasVoidAfter = function () {
        this.flags.hasVoidAfter = true;
        return this;
    };
    BehaviourBuilder.prototype.notInVoid = function () {
        this.flags.notInVoid = true;
        return this;
    };
    BehaviourBuilder.prototype.createBehaviour = function (flags, name, action) {
        return {
            name: name,
            action: function (event, editor) {
                if (!matchingEventTypes(flags, event)) {
                    return;
                }
                if (isKeyEvent(event) && !matchingKeyTypes(flags, event)) {
                    return;
                }
                if (isKeyEvent(event) && !matchingModifierTypes(flags, event)) {
                    return;
                }
                if (!matchingData(flags, event)) {
                    return;
                }
                if (flags.isCollapsed != undefined) {
                    if (!editor.selection) {
                        return;
                    }
                    if (flags.isCollapsed && slate_1.Range.isExpanded(editor.selection)) {
                        return;
                    }
                    else if (!flags.isCollapsed && slate_1.Range.isCollapsed(editor.selection)) {
                        return;
                    }
                }
                if (!atCorrectBlockPosition(flags, editor)) {
                    return;
                }
                if (!atCorrectMarkPosition(flags, editor)) {
                    return;
                }
                if (flags.hasAnyContent != undefined) {
                    var isStartEmpty = isStartBlockEmpty(editor);
                    if (flags.hasAnyContent && isStartEmpty) {
                        return;
                    }
                    else if (!flags.hasAnyContent && !isStartEmpty) {
                        return;
                    }
                }
                if (!inCorrectBlock(flags, editor)) {
                    return;
                }
                if (flags.inFullySelectedRegistryWidget) {
                    if (slate_1.Range.isRange(editor.selection) && slate_1.Range.isCollapsed(editor.selection)) {
                        var _a = __read((0, Utils_1.getClosestBlock)(editor, slate_1.Range.start(editor.selection).path), 1), closestBlockNode = _a[0];
                        var closestBlockType = closestBlockNode.type;
                        if (!(closestBlockNode.isVoid && (0, EditorWidgetRegistry_1.getGenericConfigByType)(closestBlockType))) {
                            return;
                        }
                    }
                    else {
                        return;
                    }
                }
                if (flags.inInlineType != undefined && !inCorrectInline(flags, editor)) {
                    return;
                }
                if (flags.inSingleBlock && !isInsideSingleBlock(editor)) {
                    return;
                }
                if (flags.inTableCell != undefined && flags.inTableCell != isInsideTableCell(flags, editor)) {
                    return;
                }
                if (flags.isOfAncestry != undefined && !isOfAncestry(flags, editor)) {
                    return;
                }
                if (flags.isNotOfAncestry != undefined && !isNotOfAncestry(flags, editor)) {
                    return;
                }
                if (flags.hasBlockBefore && !correctBlockBefore(flags, editor)) {
                    return;
                }
                if (flags.hasBlockAfter && !correctBlockAfter(flags, editor)) {
                    return;
                }
                if (flags.hasInlineBefore && !correctInlineBefore(flags, editor)) {
                    return;
                }
                if (flags.hasInlineAfter && !correctInlineAfter(flags, editor)) {
                    return;
                }
                if (flags.hasVoidBefore && !hasVoidBefore(editor)) {
                    return;
                }
                if (flags.hasVoidAfter && !hasVoidAfter(editor)) {
                    return;
                }
                if (flags.notInVoid && inVoid(editor)) {
                    return;
                }
                if (flags.inFirstBlock && !insideFirstBlock(editor)) {
                    return;
                }
                if (flags.inLastBlock && !insideLastBlock(editor)) {
                    return;
                }
                if (flags.inFirstElementOfContainer && !isElementFirstOfContainer(editor)) {
                    return;
                }
                if (flags.textSequence) {
                    if (!correctSequence(flags, editor)) {
                        return;
                    }
                }
                if (flags.textContent) {
                    if (!correctContent(flags, editor)) {
                        return;
                    }
                }
                var returnVal = action(event, editor);
                return returnVal;
            },
        };
    };
    return BehaviourBuilder;
}());
exports.BehaviourBuilder = BehaviourBuilder;
var matchingEventTypes = function (flags, event) {
    if (flags.isEventType == undefined) {
        return false;
    }
    else if (flags.isEventType == EditorTypes_1.EventType.Any) {
        return true;
    }
    else {
        return event.type == flags.isEventType;
    }
};
var isKeyEvent = function (event) {
    return event.type == "keydown";
};
var matchingKeyTypes = function (flags, event) {
    if (flags.isKey == undefined) {
        return false;
    }
    else if (flags.isKey == KeyType.Any) {
        return true;
    }
    else {
        return event.key == flags.isKey;
    }
};
var checkKeyModifier = function (event, modifier) {
    if (modifier === KeyModifier.CtrlCmd) {
        return event.getModifierState(KeyModifier.Ctrl) || event.getModifierState(KeyModifier.Meta);
    }
    if (modifier === KeyModifier.None) {
        return !event.ctrlKey && !event.shiftKey && !event.altKey && !event.metaKey;
    }
    return event.getModifierState(modifier);
};
var getMatchingModifiers = function (event) {
    var allKeyModifiers = Object.keys(KeyModifier).map(function (key) { return KeyModifier[key]; });
    var matchingModifiers = [];
    for (var index in allKeyModifiers) {
        var modifier = allKeyModifiers[index];
        if (checkKeyModifier(event, modifier)) {
            matchingModifiers.push(modifier);
        }
    }
    return matchingModifiers;
};
var matchingModifierTypes = function (flags, event) {
    if (event.key == KeyModifier.Ctrl ||
        event.key == KeyModifier.Shift ||
        event.key == KeyModifier.Meta ||
        event.key == KeyModifier.Alt) {
        return false;
    }
    if (flags.isOneOfKeyModifiers) {
        var matchingModifiers = getMatchingModifiers(event);
        if (matchingModifiers.length > 1) {
            if (!(matchingModifiers.length === 2 &&
                matchingModifiers.indexOf(KeyModifier.Ctrl) !== -1 &&
                matchingModifiers.indexOf(KeyModifier.CtrlCmd) !== -1)) {
                return false;
            }
        }
        var matchCount = 0;
        for (var index in flags.isOneOfKeyModifiers) {
            var modifier = flags.isOneOfKeyModifiers[index];
            var isModifierMatching = matchingModifiers.indexOf(modifier) !== -1;
            if (isModifierMatching && checkKeyModifier(event, modifier)) {
                matchCount++;
            }
        }
        return matchCount === 1;
    }
    if (flags.isKeyModifier == KeyModifier.Any) {
        return true;
    }
    else if (flags.isKeyModifier) {
        return checkKeyModifier(event, flags.isKeyModifier);
    }
    else {
        return !event.ctrlKey && !event.shiftKey && !event.altKey && !event.metaKey;
    }
};
var matchingData = function (flags, event) {
    var e_1, _a;
    if (flags.withData == undefined) {
        return true;
    }
    else {
        if (event.data == undefined) {
            return false;
        }
        try {
            for (var _b = __values(Object.keys(flags.withData)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                if (event.data[key] != flags.withData[key]) {
                    return false;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return true;
    }
};
var atCorrectBlockPosition = function (flags, editor) {
    switch (flags.inBlockPosition) {
        case Position.Any:
            return true;
        case Position.Start:
            return atStartOfBlock(editor);
        case Position.End:
            return atEndOfBlock(editor);
        case Position.Middle:
            return !atStartOfBlock(editor) && !atEndOfBlock(editor);
        default:
            return false;
    }
};
var atCorrectMarkPosition = function (flags, editor) {
    switch (flags.inMarkPosition) {
        case Position.Any:
            return true;
        case Position.End:
            return atEndOfMark(flags, editor);
        default:
            return false;
    }
};
var atStartOfBlock = function (editor) {
    if (!editor.selection) {
        return false;
    }
    var startPoint = slate_1.Range.start(editor.selection);
    var path = lodash_1.default.cloneDeep(startPoint.path);
    while (path.length > 0) {
        var index = path.pop();
        if (index !== 0) {
            return false;
        }
        var ancestor = slate_1.Editor.node(editor, path);
        if ((0, Utils_1.isBlockElement)(ancestor[0])) {
            break;
        }
    }
    return startPoint.offset == 0;
};
var atEndOfBlock = function (editor) {
    if (!editor.selection) {
        return false;
    }
    var startBlock = getBlock(editor, slate_1.Range.start(editor.selection).path);
    var selectionEnd = slate_1.Range.end(editor.selection);
    var endBlock = getBlock(editor, selectionEnd.path);
    if (!startBlock || !endBlock) {
        return false;
    }
    if (slate_1.Path.compare(startBlock[1], endBlock[1]) != 0) {
        return true;
    }
    var offsetToNode = (0, Utils_1.getOffsetFrom)(editor, endBlock[1], selectionEnd.path);
    var adjustedOffset = offsetToNode + selectionEnd.offset;
    return adjustedOffset == slate_1.Node.string(startBlock[0]).length;
};
var atEndOfMark = function (flags, editor) {
    if (!editor.selection) {
        return false;
    }
    if (!inCorrectMarkType(flags, editor)) {
        return false;
    }
    var endPoint = slate_1.Range.end(editor.selection);
    var maybeTextNodeEntry = slate_1.Editor.node(editor, endPoint);
    if (!maybeTextNodeEntry || !Text_1.Text.isText(maybeTextNodeEntry[0])) {
        return false;
    }
    var marksOfType = maybeTextNodeEntry[0].marks.filter(function (m) { return m.type === flags.inMarkType; });
    var nextTextNode = (0, Utils_1.getNext)(editor, endPoint.path, Text_1.Text.isText);
    var marksOnNextNode = nextTextNode && nextTextNode[0].marks;
    var missingMarkOnNextText = !!marksOfType.find(function (mark) { return !hasMarkEqualTo(marksOnNextNode, mark); });
    return missingMarkOnNextText && endPoint.offset === maybeTextNodeEntry[0].text.length;
};
var inCorrectBlock = function (flags, editor) {
    var e_2, _a, e_3, _b, e_4, _c;
    if (!editor.selection) {
        return (flags.notInBlockType.length === 0 && flags.inBlockType.length === 1 && flags.inBlockType[0] === EditorTypes_1.BlockType.Any);
    }
    if (!flags.notInBlockType) {
        try {
            for (var _d = __values(flags.inBlockType), _e = _d.next(); !_e.done; _e = _d.next()) {
                var type = _e.value;
                if (type === EditorTypes_1.BlockType.Any) {
                    return true;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            }
            finally { if (e_2) throw e_2.error; }
        }
    }
    var selectionPath = slate_1.Range.start(editor.selection).path;
    var closestBlockEntry = (0, Utils_1.getClosestBlock)(editor, selectionPath);
    if (!closestBlockEntry) {
        return false;
    }
    var blockType = closestBlockEntry[0].type;
    try {
        for (var _f = __values(flags.notInBlockType), _g = _f.next(); !_g.done; _g = _f.next()) {
            var type = _g.value;
            if (blockType == type) {
                return false;
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
        }
        finally { if (e_3) throw e_3.error; }
    }
    try {
        for (var _h = __values(flags.inBlockType), _j = _h.next(); !_j.done; _j = _h.next()) {
            var type = _j.value;
            if (blockType == type || type == EditorTypes_1.BlockType.Any) {
                return true;
            }
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
        }
        finally { if (e_4) throw e_4.error; }
    }
    return false;
};
var inCorrectMarkType = function (flags, editor) {
    if (!editor.selection) {
        return false;
    }
    if (flags.inMarkType === EditorTypes_1.MarkType.Any) {
        return true;
    }
    var currTextNodeEntry = slate_1.Editor.node(editor, slate_1.Range.start(editor.selection));
    if (!currTextNodeEntry || !Text_1.Text.isText(currTextNodeEntry[0])) {
        return false;
    }
    return (0, exports.hasMarkOfType)(currTextNodeEntry[0].marks, flags.inMarkType);
};
var hasMarkOfType = function (marks, markType) {
    if (!marks) {
        return false;
    }
    else {
        return marks.reduce(function (foundMark, curr) {
            return foundMark || curr.type === markType;
        }, false);
    }
};
exports.hasMarkOfType = hasMarkOfType;
var hasMarkEqualTo = function (marks, markToFind) {
    return !!(marks && marks.find(function (curr) { return lodash_1.default.isEqual(curr, markToFind); }));
};
var inCorrectInline = function (flags, editor) {
    var e_5, _a;
    if (!editor.selection) {
        return false;
    }
    var closestInlineEntry = (0, Utils_1.getClosestInline)(editor, slate_1.Range.start(editor.selection).path);
    if (!closestInlineEntry) {
        return false;
    }
    var inlineType = closestInlineEntry[0].type;
    try {
        for (var _b = __values(flags.inInlineType), _c = _b.next(); !_c.done; _c = _b.next()) {
            var type = _c.value;
            if (inlineType == type || type == EditorTypes_1.InlineType.Any) {
                return true;
            }
        }
    }
    catch (e_5_1) { e_5 = { error: e_5_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_5) throw e_5.error; }
    }
    return false;
};
var isInsideSingleBlock = function (editor) {
    if (!editor.selection) {
        return false;
    }
    var anchorEntry = (0, Utils_1.getClosestBlock)(editor, editor.selection.anchor.path);
    var focusEntry = (0, Utils_1.getClosestBlock)(editor, editor.selection.focus.path);
    if (!anchorEntry || !focusEntry) {
        return false;
    }
    return lodash_1.default.isEqual(anchorEntry[1], focusEntry[1]);
};
var isInsideTableCell = function (flags, editor) {
    if (!editor.selection) {
        return false;
    }
    return (0, Utils_1.hasAncestorOf)(editor, slate_1.Range.start(editor.selection).path, "tableCell");
};
var isOfAncestry = function (flags, editor) {
    if (!editor.selection || !flags.isOfAncestry) {
        return false;
    }
    return (0, Utils_1.hasAncestorOf)(editor, slate_1.Range.start(editor.selection).path, flags.isOfAncestry);
};
var isNotOfAncestry = function (flags, editor) {
    if (!editor.selection || !flags.isNotOfAncestry) {
        return false;
    }
    return !(0, Utils_1.hasAncestorOf)(editor, slate_1.Range.start(editor.selection).path, flags.isNotOfAncestry);
};
var correctBlockBefore = function (flags, editor) {
    var e_6, _a;
    if (!editor.selection || !flags.hasBlockBefore) {
        return false;
    }
    var previousBlock = (0, Utils_1.getPreviousSiblingBlock)(editor, slate_1.Range.start(editor.selection).path);
    if (previousBlock) {
        var blockType = previousBlock[0].type;
        try {
            for (var _b = __values(flags.hasBlockBefore), _c = _b.next(); !_c.done; _c = _b.next()) {
                var type = _c.value;
                if (blockType == type || type == EditorTypes_1.BlockType.Any) {
                    return true;
                }
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_6) throw e_6.error; }
        }
    }
    return false;
};
var correctBlockAfter = function (flags, editor) {
    var e_7, _a;
    if (!editor.selection || !flags.hasBlockAfter) {
        return false;
    }
    var nextBlock = (0, Utils_1.getNextSiblingBlock)(editor, slate_1.Range.start(editor.selection).path);
    if (nextBlock) {
        var _b = __read(nextBlock, 1), nextBlockNode = _b[0];
        var blockType = nextBlockNode.type;
        try {
            for (var _c = __values(flags.hasBlockAfter), _d = _c.next(); !_d.done; _d = _c.next()) {
                var type = _d.value;
                if (blockType == type || type == EditorTypes_1.BlockType.Any) {
                    return true;
                }
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_7) throw e_7.error; }
        }
    }
    return false;
};
var correctInlineBefore = function (flags, editor) {
    var e_8, _a;
    if (!editor.selection || !flags.hasInlineBefore) {
        return false;
    }
    var start = slate_1.Range.start(editor.selection);
    var currentNodeEntry = slate_1.Editor.node(editor, start);
    if (!(0, Utils_1.isAtStartOfNode)(slate_1.Range.end(editor.selection), currentNodeEntry)) {
        return false;
    }
    var previousTextNodeEntry = (0, Utils_1.getPrevious)(editor, start.path, Text_1.Text.isText);
    var parentBlockEntry = (0, Utils_1.getClosestBlock)(editor, start.path);
    if (!previousTextNodeEntry || !parentBlockEntry || !slate_1.Path.isAncestor(parentBlockEntry[1], previousTextNodeEntry[1])) {
        return false;
    }
    var maybeInlineEntry = (0, Utils_1.getClosestInline)(editor, previousTextNodeEntry[1]);
    if (!maybeInlineEntry) {
        return false;
    }
    else {
        var inlineType = maybeInlineEntry[0].type;
        try {
            for (var _b = __values(flags.hasInlineBefore), _c = _b.next(); !_c.done; _c = _b.next()) {
                var type = _c.value;
                if (inlineType == type || type == EditorTypes_1.InlineType.Any) {
                    return true;
                }
            }
        }
        catch (e_8_1) { e_8 = { error: e_8_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_8) throw e_8.error; }
        }
    }
    return false;
};
var correctInlineAfter = function (flags, editor) {
    var e_9, _a;
    if (!editor.selection || !flags.hasInlineAfter) {
        return false;
    }
    var end = slate_1.Range.end(editor.selection);
    var currentNodeEntry = slate_1.Editor.node(editor, end);
    if (!(0, Utils_1.isAtEndOfNode)(slate_1.Range.start(editor.selection), currentNodeEntry)) {
        return false;
    }
    var nextTextNodeEntry = (0, Utils_1.getNext)(editor, end.path, Text_1.Text.isText);
    var parentBlockEntry = (0, Utils_1.getClosestBlock)(editor, end.path);
    if (!nextTextNodeEntry || !parentBlockEntry || !slate_1.Path.isAncestor(parentBlockEntry[1], nextTextNodeEntry[1])) {
        return false;
    }
    var maybeInlineEntry = (0, Utils_1.getClosestInline)(editor, nextTextNodeEntry[1]);
    if (!maybeInlineEntry) {
        return false;
    }
    else {
        var nodeType = maybeInlineEntry[0].type;
        try {
            for (var _b = __values(flags.hasInlineAfter), _c = _b.next(); !_c.done; _c = _b.next()) {
                var type = _c.value;
                if (nodeType == type || type == EditorTypes_1.InlineType.Any) {
                    return true;
                }
            }
        }
        catch (e_9_1) { e_9 = { error: e_9_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_9) throw e_9.error; }
        }
    }
    return false;
};
var hasVoidBefore = function (editor) {
    if (!editor.selection) {
        return false;
    }
    var previousElementEntry = (0, Utils_1.getPreviousSiblingBlock)(editor, slate_1.Range.start(editor.selection).path);
    if (previousElementEntry) {
        if (slate_1.Editor.isVoid(editor, previousElementEntry[0])) {
            return true;
        }
    }
    return false;
};
var hasVoidAfter = function (editor) {
    if (!editor.selection) {
        return false;
    }
    var nextElementEntry = (0, Utils_1.getNextSiblingBlock)(editor, slate_1.Range.start(editor.selection).path);
    if (nextElementEntry) {
        if (slate_1.Editor.isVoid(editor, nextElementEntry[0])) {
            return true;
        }
    }
    return false;
};
var inVoid = function (editor) {
    if (!editor.selection) {
        return false;
    }
    var selectionPath = slate_1.Range.start(editor.selection).path;
    var closestBlockEntry = (0, Utils_1.getClosestBlock)(editor, selectionPath);
    if (!closestBlockEntry) {
        return false;
    }
    return slate_1.Editor.isVoid(editor, closestBlockEntry[0]);
};
var insideFirstBlock = function (editor) {
    if (!editor.selection) {
        return false;
    }
    var start = slate_1.Range.start(editor.selection);
    var blockEntry = (0, Utils_1.getClosestBlock)(editor, start.path);
    return !!blockEntry && editor.children[0] === blockEntry[0];
};
var insideLastBlock = function (editor) {
    if (!editor.selection) {
        return false;
    }
    var start = slate_1.Range.start(editor.selection);
    var blockEntry = (0, Utils_1.getClosestBlock)(editor, start.path);
    return !!blockEntry && editor.children[editor.children.length - 1] === blockEntry[0];
};
var correctSequence = function (flags, editor) {
    if (!editor.selection || !flags.textSequence) {
        return false;
    }
    var start = slate_1.Range.start(editor.selection);
    var blockEntry = (0, Utils_1.getClosestBlock)(editor, start.path);
    if (!blockEntry) {
        return false;
    }
    var fullText = slate_1.Node.string(blockEntry[0]);
    var text = fullText.slice(0, start.offset + (0, Utils_1.getOffsetFrom)(editor, blockEntry[1], start.path));
    var found = flags.textSequence.test(text);
    return found;
};
var correctContent = function (flags, editor) {
    if (!editor.selection) {
        return false;
    }
    var start = slate_1.Range.start(editor.selection);
    var blockEntry = (0, Utils_1.getClosestBlock)(editor, start.path);
    if (!blockEntry) {
        return false;
    }
    var text = slate_1.Node.string(blockEntry[0]);
    return flags.textContent.test(text);
};
var getBlock = function (editor, path) {
    var e_10, _a;
    var ancestors = slate_1.Path.ancestors(path);
    try {
        for (var ancestors_1 = __values(ancestors), ancestors_1_1 = ancestors_1.next(); !ancestors_1_1.done; ancestors_1_1 = ancestors_1.next()) {
            var ancestorPath = ancestors_1_1.value;
            var ancestor = slate_1.Editor.node(editor, ancestorPath);
            if (slate_1.Editor.isBlock(editor, ancestor[0])) {
                return ancestor;
            }
        }
    }
    catch (e_10_1) { e_10 = { error: e_10_1 }; }
    finally {
        try {
            if (ancestors_1_1 && !ancestors_1_1.done && (_a = ancestors_1.return)) _a.call(ancestors_1);
        }
        finally { if (e_10) throw e_10.error; }
    }
    return;
};
var isStartBlockEmpty = function (editor) {
    if (!editor.selection) {
        return false;
    }
    var start = slate_1.Range.start(editor.selection);
    var node = (0, Utils_1.getClosestBlock)(editor, start.path);
    if (!node) {
        return false;
    }
    return slate_1.Editor.isEmpty(editor, node[0]);
};
var isElementFirstOfContainer = function (editor) {
    var _a;
    var selectionPath = (_a = editor.selection) === null || _a === void 0 ? void 0 : _a.anchor.path;
    if (!selectionPath)
        return false;
    var nodePath = slate_1.Path.parent(selectionPath);
    var nodeIsFirstInContainer = (0, lodash_1.last)(nodePath) === 0;
    return nodeIsFirstInContainer;
};
